import beforeEnterPage from "./before-enter-page";
// import chatMessageBox from "./chat-message-box";
// import chatMessageItem from "./chat-message-item";
import chatEmotion from "./chat-emotion";
// import chatBoxAndInput from "./chat-box-and-input";
// import evaluateAndConnect from "./evaluate-and-connect";
import evaluatePage from "./evaluate-page";
import avatar from "./avatar";
import socketStatus from "./socket-status";
import accountSelect from "./account-select";
import uploadImageMessage from "./upload-image-message";
export default {
  beforeEnterPage,
  // chatMessageBox,
  // chatMessageItem,
  chatEmotion,
  // chatBoxAndInput,
  // evaluateAndConnect,
  evaluatePage,
  avatar,
  accountSelect,
  socketStatus,
  uploadImageMessage
};
